(function(){
  var $ = function(s,r){return (r||document).querySelector(s);};
  var $$ = function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  var money = function(c){return '$' + (c/100).toFixed(2);};
  var FREE_SHIP = (window.MERRIOTT && window.MERRIOTT.freeShip) || 15000; // cents

  /* ---------- cart drawer ---------- */
  function openCart(){ $('#Drawer').classList.add('open'); $('#Scrim').classList.add('open'); }
  function closeCart(){ $('#Drawer').classList.remove('open'); $('#Scrim').classList.remove('open'); }

  function kindOf(it){
    var h = (it.handle || '').toLowerCase();
    if (h === 'cloud-hoodie' || /hoodie/.test(h)) return 'hoodie';
    if (h === 'cloud-sweats' || h === 'cloud-pant' || /sweat|pant/.test(h)) return 'sweats';
    if (h === 'cloud-set' || /set/.test(h)) return 'set';
    return '';
  }

  function variantId(piece, size){
    var cat = (window.MERRIOTT && window.MERRIOTT.catalog && window.MERRIOTT.catalog[piece]) || {};
    var map = cat.variants || {};
    return map[size] || map['L'] || map[Object.keys(map)[0]];
  }

  function upsellOffer(cart){
    var has = {}, size = {};
    (cart.items || []).forEach(function(it){
      var k = kindOf(it);
      if (!k) return;
      has[k] = true;
      var sz = (it.variant_title || '').split(' / ')[0];
      if (sz && !size[k]) size[k] = sz;
    });
    if (has.set) return null;
    var cat = (window.MERRIOTT && window.MERRIOTT.catalog) || {};
    var setPrice = (cat.set && cat.set.price) || 16000;
    var compare = (cat.set && cat.set.compare) || 17600;
    if (has.hoodie && has.sweats){
      return { mode: 'upgrade', size: size.hoodie || size.sweats || 'L', setPrice: setPrice, compare: compare };
    }
    if (has.hoodie && cat.sweats){
      return { mode: 'add', piece: 'sweats', size: size.hoodie || 'L', item: cat.sweats, setPrice: setPrice, compare: compare };
    }
    if (has.sweats && cat.hoodie){
      return { mode: 'add', piece: 'hoodie', size: size.sweats || 'L', item: cat.hoodie, setPrice: setPrice, compare: compare };
    }
    return null;
  }

  function upsellHtml(cart){
    var offer = upsellOffer(cart);
    if (!offer) return '';
    var img = offer.mode === 'upgrade'
      ? ((window.MERRIOTT.catalog.set && window.MERRIOTT.catalog.set.image) || '')
      : (offer.item.image || '');
    var save = money((offer.compare || 17600) - (offer.setPrice || 16000));
    var more = offer.mode === 'add'
      ? money((offer.setPrice || 16000) - (offer.item.price || 8800))
      : '';
    var copy = offer.mode === 'upgrade'
      ? '<b>Complete the set</b>Swap to The Cloud Set — <span class="was">' + money(offer.compare) + '</span>' + money(offer.setPrice) + ' (save ' + save + ')'
      : '<b>Complete the set</b>Add ' + offer.item.title + ' for ' + more + ' more. Set total ' + money(offer.setPrice) + ', save ' + save + '.';
    var label = offer.mode === 'upgrade' ? 'Upgrade' : 'Add';
    return '<div class="upsell">'
      + '<div class="upsell-img" style="background-image:url(' + img + ')"></div>'
      + '<div class="upsell-copy">' + copy + '</div>'
      + '<button type="button" class="btn btn--cta" id="UpsellAdd" data-size="' + (offer.size || 'L') + '">' + label + '</button>'
      + '</div>';
  }

  function completeSet(size){
    var setId = variantId('set', size);
    if (!setId) return;
    var btn = $('#UpsellAdd');
    if (btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
    return fetch(window.routes.cart)
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var updates = {};
        cart.items.forEach(function(it){
          var k = kindOf(it);
          if (k === 'hoodie' || k === 'sweats') updates[it.key] = 0;
        });
        var next = Object.keys(updates).length
          ? fetch(window.routes.cart_update, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ updates: updates })
            })
          : Promise.resolve();
        return next.then(function(){
          return fetch(window.routes.cart_add, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: setId, quantity: 1 })
          });
        });
      })
      .then(function(){ return fetchCart(); })
      .catch(function(){ if (btn){ btn.disabled = false; btn.textContent = 'Add'; } });
  }

  function renderCart(cart){
    var count = cart.item_count;
    var cc = $('#CartCount');
    if(cc){ cc.textContent = count; cc.classList.toggle('is-empty', count===0); }
    var body = $('#DrawerBody'), foot = $('#DrawerFoot');
    if(!body) return;
    if(!cart.items.length){
      body.innerHTML = '<div class="cart-empty">Your bag is empty.</div>';
      foot.innerHTML = ''; return;
    }
    body.innerHTML = cart.items.map(function(it){
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_200x$1$2') : '';
      return '<div class="line">'
        + '<div class="line-img" style="background-image:url('+img+')"></div>'
        + '<div class="line-info"><div class="nm">'+it.product_title+'</div>'
        + '<div class="vr">'+ (it.variant_title ? it.variant_title.replace(/ \/ /g,' · ') : '') +'</div>'
        + '<div class="qty"><button data-key="'+it.key+'" data-q="'+(it.quantity-1)+'">−</button>'
        + '<span>'+it.quantity+'</span>'
        + '<button data-key="'+it.key+'" data-q="'+(it.quantity+1)+'">+</button></div></div>'
        + '<div class="line-right"><span class="pr">'+money(it.final_line_price)+'</span>'
        + '<button class="rm" data-key="'+it.key+'" data-q="0">Remove</button></div></div>';
    }).join('') + upsellHtml(cart);
    var sub = cart.total_price;
    foot.innerHTML = '<p class="ship-note">Pre-order. Ships after October 10. Shipping calculated at checkout.</p>'
      + '<div class="subtotal"><span>Subtotal</span><span class="v">'+money(sub)+'</span></div>'
      + '<button class="btn btn--cta btn--block" id="CheckoutBtn">Checkout</button>';
  }

  function fetchCart(){ return fetch(window.routes.cart).then(function(r){return r.json();}).then(function(cart){ renderCart(cart); return cart; }); }

  function addToCart(form){
    var data = new FormData(form);
    return fetch(window.routes.cart_add, {method:'POST', headers:{'Accept':'application/json'}, body:data})
      .then(function(r){return r.json();})
      .then(function(){ return fetchCart(); })
      .then(function(){ openCart(); });
  }

  function changeQty(key, q){
    fetch(window.routes.cart_change, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity:q})})
      .then(function(r){return r.json();}).then(renderCart);
  }

  document.addEventListener('click', function(e){
    var t = e.target;
    if(t.closest('#CartOpen')){ e.preventDefault(); openCart(); }
    if(t.closest('#DrawerClose') || t.id==='Scrim'){ closeCart(); }
    if(t.id==='CheckoutBtn'){ window.location.href = window.routes.checkout; }
    if(t.closest('#UpsellAdd')){ e.preventDefault(); completeSet(t.closest('#UpsellAdd').getAttribute('data-size') || 'L'); return; }
    if(t.matches('.qty button, .rm')){ changeQty(t.getAttribute('data-key'), parseInt(t.getAttribute('data-q'),10)); }
  });

  /* product add-to-cart forms (desktop + mobile share the variant id) */
  $$('form[data-product-form]').forEach(function(form){
    form.addEventListener('submit', function(e){ e.preventDefault(); addToCart(form); });
  });

  fetchCart();

  /* ---------- product: variants, swatches, gallery ---------- */
  var pd = $('#ProductData');
  if(pd){
    var variants = JSON.parse(pd.textContent);
    var selected = {};
    var idInput = $('#VariantId');
    var idPay = $('#VariantIdPay');
    var mobileId = $('#VariantIdMobile');
    var priceEls = $$('[data-price]');
    var addBtns = $$('[data-add-btn]');

    var hasOpts = $$('[data-opt]').length > 0;
    function currentVariant(){
      if(!hasOpts) return variants[0];
      return variants.find(function(v){
        return v.options.every(function(o,i){ return selected[i]===o; });
      });
    }
    function update(){
      var v = currentVariant();
      var ready = !!v;
      addBtns.forEach(function(b){
        b.disabled = !ready || (v && !v.available);
        b.textContent = !ready ? 'Select options' : (v.available ? (b.getAttribute('data-add-label')||'Add to bag') : 'Sold out');
      });
      if(v){
        if(idInput) idInput.value = v.id;
        if(idPay) idPay.value = v.id;
        if(mobileId) mobileId.value = v.id;
        priceEls.forEach(function(el){ el.textContent = money(v.price); });
      }
    }
    $$('[data-opt]').forEach(function(group){
      var idx = parseInt(group.getAttribute('data-opt'),10);
      $$('button', group).forEach(function(btn){
        if(btn.getAttribute('data-default')==='true'){ selected[idx]=btn.getAttribute('data-value'); }
        btn.addEventListener('click', function(){
          selected[idx] = btn.getAttribute('data-value');
          $$('button', group).forEach(function(b){ b.classList.remove('on'); });
          btn.classList.add('on');
          update();
        });
      });
    });
    update();

    /* gallery thumbs */
    $$('.pd-thumbs button').forEach(function(b){
      b.addEventListener('click', function(){
        var main = $('#PdMain');
        main.style.backgroundImage = 'url('+b.getAttribute('data-img')+')';
        main.classList.toggle('is-cover', b.getAttribute('data-cover') === 'true');
        $$('.pd-thumbs button').forEach(function(x){x.classList.remove('on');});
        b.classList.add('on');
      });
    });

    var qtyInput = $('#QtyInput');
    var qtyPay = $('#QtyInputPay');
    var qtyVal = $('#QtyVal');
    function setQty(n){
      n = Math.max(1, n);
      if(qtyInput) qtyInput.value = n;
      if(qtyPay) qtyPay.value = n;
      if(qtyVal) qtyVal.textContent = n;
    }
    if($('#QtyMinus')) $('#QtyMinus').addEventListener('click', function(){ setQty(parseInt((qtyInput && qtyInput.value) || '1', 10) - 1); });
    if($('#QtyPlus')) $('#QtyPlus').addEventListener('click', function(){ setQty(parseInt((qtyInput && qtyInput.value) || '1', 10) + 1); });
  }

  /* ---------- size picker (add to bag outside the PDP) ---------- */
  var sp = $('#SizePicker');
  var spReturn = null;

  function spSizes(cat){
    if (cat.sizes && cat.sizes.length) return cat.sizes;
    // Older catalog shape carried only the variants map, with no availability.
    var map = cat.variants || {};
    return Object.keys(map).map(function(t){ return { t: t, id: map[t], a: true }; });
  }

  function spOpen(piece, trigger){
    var cat = window.MERRIOTT && window.MERRIOTT.catalog && window.MERRIOTT.catalog[piece];
    // No picker or no data: let the click fall through to the product page.
    if (!sp || !cat) return false;

    var sizes = spSizes(cat);
    if (!sizes.length) return false;

    spReturn = trigger || null;
    $('#SizePickerName').textContent = cat.title || '';
    $('#SizePickerPrice').textContent = cat.price ? money(cat.price) : '';

    var img = $('#SizePickerImg');
    if (cat.image) { img.src = cat.image; img.alt = cat.title || ''; img.hidden = false; }
    else { img.hidden = true; }

    var guide = $('#SizePickerGuide');
    if (guide && cat.handle) guide.href = '/products/' + cat.handle + '#size-guide';

    $('#SizePickerSizes').innerHTML = sizes.map(function(s){
      return '<button type="button" class="opt sp-size' + (s.a ? '' : ' soldout') + '" data-id="' +
        s.id + '"' + (s.a ? '' : ' disabled') + '>' + s.t + '</button>';
    }).join('');

    $('#SizePickerNote').hidden = sizes.some(function(s){ return s.a; });

    sp.hidden = false;
    requestAnimationFrame(function(){ sp.classList.add('open'); });
    var first = sp.querySelector('.sp-size:not([disabled])');
    if (first) first.focus();
    return true;
  }

  function spClose(){
    if (!sp || sp.hidden) return;
    sp.classList.remove('open');
    setTimeout(function(){ sp.hidden = true; }, 300);
    if (spReturn) { spReturn.focus(); spReturn = null; }
  }

  function spAdd(id, btn){
    if (btn) btn.classList.add('is-adding');
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', 1);
    return fetch(window.routes.cart_add, { method:'POST', headers:{'Accept':'application/json'}, body: fd })
      .then(function(r){ return r.json(); })
      .then(function(){ return fetchCart(); })
      .then(function(){ spClose(); openCart(); })
      .catch(function(){ if (btn) btn.classList.remove('is-adding'); });
  }

  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-size-picker]');
    if (trigger) {
      if (spOpen(trigger.getAttribute('data-size-picker'), trigger)) e.preventDefault();
      return;
    }
    if (!sp || sp.hidden) return;
    if (e.target === sp || e.target.closest('.sp-close')) { spClose(); return; }
    var size = e.target.closest('.sp-size');
    if (size && !size.disabled) { spAdd(size.getAttribute('data-id'), size); }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') spClose();
  });

  /* ---------- sms popup ---------- */
  var pop = $('#PopScrim');
  function openPop(){ if(!pop || sessionShown()) return; pop.classList.add('open'); try{sessionStorage.setItem('mpop','1');}catch(e){} }
  function sessionShown(){ try{return sessionStorage.getItem('mpop')==='1';}catch(e){return false;} }
  function closePop(){ if(pop) pop.classList.remove('open'); }
  if(pop){
    var delay = parseInt(pop.getAttribute('data-delay'),10) || 700;
    if(!sessionShown()) setTimeout(openPop, delay);
    document.addEventListener('click', function(e){
      if(e.target.closest('#PopClose') || e.target===pop || e.target.closest('#PopDismiss')) closePop();
      if(e.target.closest('#PromoStrip')){ try{sessionStorage.removeItem('mpop');}catch(err){} pop.classList.add('open'); }
    });
  }
})();
